<template>
  <div>
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12 sm6>
          <v-btn
            depressed
            :outline="filter != 'all'"
            :color="filter == 'all' ? 'primary' : 'grey'"
            @click="
              filter = 'all'
              getSummary()
            "
            class="ma-0 mr-1 mb-1"
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="filter != 'facebook'"
            :color="filter == 'facebook' ? 'primary' : 'grey'"
            @click="
              filter = 'facebook'
              getSummary()
            "
            class="ma-0 mr-1 mb-1"
          >
            <i class="fab fa-facebook-square mr-1"></i>
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="filter != 'line'"
            :color="filter == 'line' ? 'primary' : 'grey'"
            @click="
              filter = 'line'
              getSummary()
            "
            class="ma-0 mr-1 mb-1"
          >
            <i class="fab fa-line mr-1"></i>
            {{ $t('Line') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-sm-right">
          <template v-if="loading">
            <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
          </template>
          <template v-else>
            <v-btn
              v-if="$store.getters.getPackage != 'premium'"
              outline
              v-tooltip.top="'Unlock to PREMIUM plan'"
              color="grey"
              class="ma-0 mb-1"
            >
              <i class="fas fa-file-export mr-1"></i>
              <span class="mr-2">{{ $t('export') }}</span>
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
            <v-btn
              v-else-if="$store.getters.getPackage == 'premium'"
              @click="exportDashboard"
              color="grey"
              outline
              class="ma-0 mb-1"
            >
              <i class="fas fa-file-export mr-1"></i>
              {{ $t('export') }}
            </v-btn>
          </template>
        </v-flex>
      </v-layout>

      <date-filter v-model="selectedDate" @onSelected="getSummary"></date-filter>
      <h3 class="title mt-5 mb-2">{{ $t('Total number of users since installing chatbot') }}</h3>
      <!-- <p class="title">{{$t('Total number of users since installing chatbot')}}</p> -->
      <v-layout wrap>
        <v-flex xs12 sm12 md6 lg5 class="pa-1">
          <v-card style="border-radius: 5px">
            <v-card-title>
              <span>{{ $t('total user') }}</span>
            </v-card-title>
            <div class="body">
              <div class style="position:relative;">
                <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
                <template v-if="totaluserSeries">
                  <div style="max-width: 350px;margin: auto">
                    <apexchart
                      ref="totaluser"
                      type="pie"
                      :options="totaluser"
                      :series="totaluserSeries"
                    ></apexchart>
                  </div>
                </template>
              </div>
            </div>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md6 lg7>
          <v-layout wrap>
            <v-flex xs12 sm6 md6 lg12 class="pa-1">
              <stat-card v-model="summary.totalusers" :loading="loading">
                {{ $t('total user') }}
              </stat-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
              <stat-card v-model="totaluserSeries[2]" :loading="loading">
                {{ $t('no gender') }}
                <span
                  style="color:#d4d4d4"
                  v-tooltip.top="
                    $t('Number of non-male and non-female users who talked with chatbot (All time)')
                  "
                >
                  <i class="fas fa-info-circle"></i>
                </span>
              </stat-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
              <stat-card v-model="totaluserSeries[0]" :loading="loading">
                {{ $t('male') }}
                <span
                  style="color:#d4d4d4"
                  v-tooltip.top="$t('Number of male users who talked with chatbot (All time)')"
                >
                  <i class="fas fa-info-circle"></i>
                </span>
              </stat-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
              <stat-card v-model="totaluserSeries[1]" :loading="loading">
                {{ $t('Female') }}
                <span
                  style="color:#d4d4d4"
                  v-tooltip.top="$t('Number of female users who talked with chatbot (All time)')"
                >
                  <i class="fas fa-info-circle"></i>
                </span>
              </stat-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg6 fill-height class="pa-1">
              <stat-card v-model="summary.activeusers" :loading="loading">
                {{ $t('active users') }}
                <span
                  style="color:#d4d4d4"
                  v-tooltip.top="
                    $t('Number of users who talked with chatbot during') +
                      ' ' +
                      dateFormat(selectedDate.start, 'DD/MM/YYYY') +
                      ' - ' +
                      dateFormat(selectedDate.end, 'DD/MM/YYYY')
                  "
                >
                  <i class="fas fa-info-circle"></i>
                </span>
              </stat-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg6 fill-height class="pa-1">
              <stat-card v-model="summary.newusers" :loading="loading">
                {{ $t('new users') }}
                <span
                  style="color:#d4d4d4"
                  v-tooltip.top="
                    $t('Number of new users who talked with chatbot during') +
                      ' ' +
                      dateFormat(selectedDate.start, 'DD/MM/YYYY') +
                      ' - ' +
                      dateFormat(selectedDate.end, 'DD/MM/YYYY')
                  "
                >
                  <i class="fas fa-info-circle"></i>
                </span>
              </stat-card>
            </v-flex>

            <v-divider />
          </v-layout>
        </v-flex>
      </v-layout>

      <!-- <v-divider class="mt-2 mb-2" /> -->
      <v-layout wrap class="hidden-sm-and-up">
        <!--         <v-flex xs12 sm6 md6 lg6 fill-height class="pa-1 pr-1 ">
          <h3 class="title">
            {{ $t('Total number of messages received since installing chatbot') }}
          </h3>
          <stat-card v-model="summary.totalmessages" :loading="loading">
            {{ $t('total messages') }}
            <span
              style="color:#d4d4d4"
              v-tooltip.top="$t('Number of messages that chatbot had replied (All time)')"
            >
              <i class="fas fa-info-circle"></i>
            </span>
          </stat-card>
        </v-flex> -->
        <v-flex xs12 sm6 md6 lg6 fill-height class="pa-1 pl-2">
          <h3 class="title">{{ $t('Current number of messages received') }}</h3>
          <stat-card v-model="summary.activemessages" :loading="loading">
            {{ $t('active messages') }}
            <span
              style="color:#d4d4d4"
              v-tooltip.top="
                $t('Number of messages that chatbot had replied during') +
                  ' ' +
                  dateFormat(selectedDate.start, 'DD/MM/YYYY') +
                  ' - ' +
                  dateFormat(selectedDate.end, 'DD/MM/YYYY')
              "
            >
              <i class="fas fa-info-circle"></i>
            </span>
          </stat-card>
        </v-flex>
      </v-layout>

      <v-layout wrap class="hidden-xs-only">
        <!--         <v-flex xs12 sm6 md6 lg6 fill-height class="pa-1 pr-1 ">
          <h3 class="title">
            {{ $t('Total number of messages received since installing chatbot') }}
          </h3>
        </v-flex> -->
        <v-flex xs12 sm12 md12 lg12 fill-height class="pa-1 pl-2">
          <h3 class="title">{{ $t('Current number of messages received') }}</h3>
        </v-flex>
        <!--         <v-flex sm12 fill-height class="pa-1 pr-1 ">
          <stat-card v-model="summary.totalmessages" :loading="loading">
            {{ $t('total messages') }}
            <span
              style="color:#d4d4d4"
              v-tooltip.top="$t('Number of messages that chatbot had replied (All time)')"
            >
              <i class="fas fa-info-circle"></i>
            </span>
          </stat-card>
        </v-flex> -->

        <v-flex sm12 fill-height class="pa-1 pr-1 ">
          <stat-card v-model="summary.activemessages" :loading="loading">
            {{ $t('active messages') }}
            <span
              style="color:#d4d4d4"
              v-tooltip.top="
                $t('Number of messages that chatbot had replied during') +
                  ' ' +
                  dateFormat(selectedDate.start, 'DD/MM/YYYY') +
                  ' - ' +
                  dateFormat(selectedDate.end, 'DD/MM/YYYY')
              "
            >
              <i class="fas fa-info-circle"></i>
            </span>
          </stat-card>
        </v-flex>
      </v-layout>

      <h3 class="title mt-5 mb-2">{{ $t('Comment') }}</h3>
      <v-layout wrap>
        <!--         <v-flex xs12 sm6 md4 lg3 class="pa-1">
          <stat-card v-model="summary.totalreplycomments" :loading="loading">{{
            $t('Total reply comments')
          }}</stat-card>
        </v-flex> -->
        <!--         <v-flex xs12 sm6 md4 lg3 class="pa-1">
          <stat-card v-model="summary.totalreplyinbox" :loading="loading">{{
            $t('Total reply inbox')
          }}</stat-card>
        </v-flex> -->
        <!--         <v-flex xs12 sm6 md4 lg3 class="pa-1">
          <stat-card v-model="summary.totalhidecomment" :loading="loading">{{
            $t('Total hide comments')
          }}</stat-card>
        </v-flex> -->
        <v-flex xs12 sm6 md4 lg4 class="pa-1">
          <stat-card v-model="summary.activereplycomments" :loading="loading">{{
            $t('Active reply comments')
          }}</stat-card>
        </v-flex>
        <v-flex xs12 sm6 md4 lg4 class="pa-1">
          <stat-card v-model="summary.activereplyinbox" :loading="loading">{{
            $t('Active reply inbox')
          }}</stat-card>
        </v-flex>
        <v-flex xs12 sm6 md4 lg4 class="pa-1">
          <stat-card v-model="summary.activehidecomment" :loading="loading">{{
            $t('Active hide comments')
          }}</stat-card>
        </v-flex>
        <v-flex xs12 sm6 md4 lg3 class="pa-1"></v-flex>
      </v-layout>
    </v-container>
    <div class="mt-5 mb-5"></div>
  </div>
</template>

<script>
import DateFilter from './DateFilter'
import { mapGetters } from 'vuex'
import api from '@/api'

import moment from 'moment'
import numeral from 'numeral'

import VueApexCharts from 'vue-apexcharts'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

import StatCard from './StatCard'
import DashboardGraphLoading from './DashboardGraphLoading'

export default {
  components: {
    DateFilter,
    StatCard,
    ScaleLoader,
    PulseLoader,
    apexchart: VueApexCharts,
    DashboardGraphLoading
  },
  data: function() {
    return {
      summary: {
        totalmessages: 0,
        activemessages: 0,
        activeusers: 0,
        totalusers: 0,
        newusers: 0
      },
      loading: true,
      filter: 'all',
      totaluserSeries: [0, 0, 0],
      totaluser: {
        chart: {
          type: 'pie'
          // height: 350
        },
        labels: [this.$t('male'), this.$t('female'), this.$t('no gender')],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        legend: {
          show: true,
          position: 'bottom'
        }
      },
      selectedDate: {
        start: moment()
          .startOf('month')
          .format('YYYY-MM-DD'),
        end: moment()
          .endOf('month')
          .format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  mounted: function() {
    this.getSummary()
  },
  methods: {
    dateFormat: function(date, format) {
      return moment(date).format(format)
    },
    getSummary: function() {
      let vm = this
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'),
        dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'),
        app: this.filter
      }
      vm.loading = true
      api.getDashboardSummary(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.loading = false
          return
        }
        if (response.data) {
          if (response.data.length > 0) {
            vm.summary.totalmessages = response.data[0].totalmessages
            vm.summary.activemessages = response.data[0].activemessages
            vm.summary.activeusers = response.data[0].activeusers
            vm.summary.totalusers = response.data[0].totalusers
            vm.summary.newusers = response.data[0].newusers

            vm.summary.totalhidecomment = response.data[0].totalhidecomment
            vm.summary.totalreplycomments = response.data[0].totalreplycomments
            vm.summary.totalreplyinbox = response.data[0].totalreplyinbox
            vm.summary.activehidecomment = response.data[0].activehidecomment
            vm.summary.activereplycomments = response.data[0].activereplycomments
            vm.summary.activereplyinbox = response.data[0].activereplyinbox

            vm.totaluserSeries = [
              parseInt(response.data[0].totalusers_male),
              parseInt(response.data[0].totalusers_female),
              parseInt(response.data[0].totalusers_other)
            ]
          } else {
            vm.summary.totalmessages = 0
            vm.summary.activemessages = 0
            vm.summary.activeusers = 0
            vm.summary.totalusers = 0
            vm.summary.newusers = 0

            vm.totaluserSeries = [0, 0, 0]
          }
        }
        vm.$nextTick(function() {
          vm.loading = false
        })
      })
    },
    exportDashboard: function() {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }

      csvContent +=
        'From,"' +
        moment(vm.selectedDate.start).format('DD/MM/YYYY') +
        '",To,"' +
        moment(vm.selectedDate.end).format('DD/MM/YYYY') +
        '"\r\n'
      csvContent += '\r\n'
      csvContent += 'Total Users,"' + numeral(vm.summary.totalusers).format('0,0') + '"\r\n'
      csvContent +=
        'No Gender Users,"' +
        numeral(parseInt(vm.totaluserSeries[2])).format('0,0') +
        '","' +
        numeral((vm.totaluserSeries[2] * 100) / vm.summary.totalusers).format('0.0') +
        '%"\r\n'
      csvContent +=
        'Male Users,"' +
        numeral(parseInt(vm.totaluserSeries[0])).format('0,0') +
        '","' +
        numeral((vm.totaluserSeries[0] * 100) / vm.summary.totalusers).format('0.0') +
        '%"\r\n'
      csvContent +=
        'Female Users,"' +
        numeral(parseInt(vm.totaluserSeries[1])).format('0,0') +
        '","' +
        numeral((vm.totaluserSeries[1] * 100) / vm.summary.totalusers).format('0.0') +
        '%"\r\n'
      csvContent += 'Active Users,"' + numeral(vm.summary.activeusers).format('0,0') + '"\r\n'
      csvContent += 'New Users,"' + numeral(vm.summary.newusers).format('0,0') + '"\r\n'
      csvContent += 'Total Messages,"' + numeral(vm.summary.totalmessages).format('0,0') + '"\r\n'
      csvContent += 'Active Messages,"' + numeral(vm.summary.activemessages).format('0,0') + '"\r\n'
      csvContent += '\r\n'

      vm.exportCsv(csvContent, 'crm')
    }
  },
  filters: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style lang="scss" scoped>
.totalmessagex {
  border-right: 1px solid #cecece;
  padding-right: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/dashboard/StatSummary.vue